(function () {
  if (customElements.get('healr-scroller')) return;

  class HealrScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-healr-track]');
      if (!this.track) return;
      this.isDown = false;
      this.startX = 0;
      this.startScroll = 0;
      this.moved = false;

      this.onDown = this.onDown.bind(this);
      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);

      this.track.addEventListener('pointerdown', this.onDown);
      // If a drag happened, swallow the resulting click in the capture phase
      // so it never reaches child toggles (e.g. video play/pause).
      this.track.addEventListener('click', (e) => {
        if (this.moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    }

    onDown(e) {
      if (e.pointerType === 'touch') return; // let native touch scrolling handle it
      this.isDown = true;
      this.moved = false;
      this.startX = e.clientX;
      this.startScroll = this.track.scrollLeft;
      /* NOTE: do NOT setPointerCapture here. Since Chrome 76+, the capturing
         element becomes the target of the follow-up `click`, which stole the
         click from the play button inside the carousel (video never played).
         Window-level move/up listeners already keep drag working without it. */
      this.track.classList.add('is-dragging');
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
    }

    onMove(e) {
      if (!this.isDown) return;
      const dx = e.clientX - this.startX;
      if (Math.abs(dx) > 4) this.moved = true;
      this.track.scrollLeft = this.startScroll - dx;
    }

    onUp() {
      this.isDown = false;
      this.track.classList.remove('is-dragging');
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
    }
  }

  customElements.define('healr-scroller', HealrScroller);
})();
